import React from 'react'
import { Link } from 'react-router-dom'
import dateHelper from '../../util/dateFormatter'
import { Translation } from 'react-i18next'
import i18n from '../../languages/lang.js'

const DirectoryList = props => {
  if (!props.data) {
    return (
      <Translation>
        {
          (t) => (
            <div id={'loading'}>{t('system.loading')}</div>
          )
        }
      </Translation>
    )
  }

  if (props.data.length === 0) {
    return null
  }

  return (
    props.data.map(item => {
      return (
        <tr key={item.key}>
          <td className='directory' colSpan='3'>
            <Link to={`/files?directory=${item.key}`}><i className="fad fa-folder"></i> {item.name}</Link>
          </td>
          <td className='sub last'>
            <Link to={`/files?directory=${item.key}`}>{dateHelper.Formatter.toLocalString(item.created)}</Link>
          </td>
        </tr>
      )
    })
  )
}

export default DirectoryList
